<p-progressSpinner styleClass="loader__progress"></p-progressSpinner>
<div class="loader__overlay"></div>
